import configuration from '../../configuration';
import ODataFulogicsStore from 'fulogics-ui-core/dist/api/odata/ODataFulogicsStore';
import { getUserToken } from 'fulogics-ui-core';
import { createModel } from '@rematch/core';
import { iRootModel } from '../iRootModel';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import Singleton from 'fulogics-ui-core/dist/Singleton';
import fromODataResponse from 'fulogics-ui-core/dist/api/odata/fromODataResponse';
import { COSOrderForwardStepStore } from './COSOrderForwardStepModel';
import { deleteOrderStepReturnItemPayload } from './COSOrderReturnStepCollectionModel';

export const COSOrderForwardStepCollectionODataEndpoint = `${configuration.API_BASE_URL}/odata/ForwardStepsCollections/Store`;
export const COSOrderForwardStepCollectionStore = ODataFulogicsStore({
    url: COSOrderForwardStepCollectionODataEndpoint,
    key: 'id',
    keyType: 'String',
});

export type COSOrderForwardStepCollectionState = {};

export const COSOrderForwardStepCollectionModel = createModel<iRootModel>()({
    state: {} as COSOrderForwardStepCollectionState,
    effects: (dispatch) => ({
        /*async insertItem<T>(payload: insertOrderForwardStepItemPayload & { data?: T }) {
            //https://fulogics-client-order-system-api-dev.azurewebsites.net/ForwardStepsCollections/InsertOrderForwardStep
            let createResponse = await Singleton.apiClient.post<{ title?: string, detail?: string, id?: string }>("/odata/COSOrders/createNew", {});
            fromODataResponse(createResponse, [200, 204]);
            //
            return {id: createResponse.data?.id}
        },*/
        async deleteItem<T>(payload: deleteOrderStepForwardItemPayload & { data?: T }) {
            /*todo*/
        },
    }),

    selectors: (slice, createSelector, hasProps) => ({
        /*dxStore nie istnieje*/
        //
        /*
        createItemsCollectionDataSource : hasProps(function (models, collectionId) {
            return slice(() => ({
                store: COSOrderForwardStepStore,
                    reshapeOnPush: true,
                    customQueryParams:
                {
                    collectionId: collectionId
                }
            } as DataSourceOptions))
        }),*/
        /*
                createItemsCollectionDataSource: (models, collectionId: string) => {
                    return {
                        store: COSOrderForwardStepStore,
                        reshapeOnPush: true,
                        customQueryParams:
                            {
                                collectionId: collectionId
                            }
                    } as DataSourceOptions
                },*/
    }),
});

export type deleteOrderStepForwardItemPayload = {};
export default COSOrderForwardStepCollectionModel;

export type insertOrderForwardStepItemPayload = {
    responseKeys?: string[];
    responseData?: any;
};
